import { onSnapshot, doc, getFirestore, updateDoc } from 'firebase/firestore'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { setPlayers, startGame } from '../../reducers/gameReducer'
import { generateCards, getGameChanges } from '../../services/gameService'

const Lobby = () => {
  const game = useSelector(state => state.game)
  const user = useSelector(state => state.user)
  const history = useHistory()
  const db = getFirestore()
  const dispatch = useDispatch()

  const handleStart = async () => {
    const gameRef = doc(db, "games", game.id)
    await generateCards(game.id)
    await updateDoc(gameRef, {
      running: true
    })
    dispatch(startGame())
    history.push('/loading')
  }

  useEffect(() => {
    const unsubGame = onSnapshot(doc(db, "games", game.id), async (doc) => {
      const source = doc.metadata.hasPendingWrites ? "Local" : "Server"
      if (source === 'Local') return

      const gameState = doc.data()
      const changes = getGameChanges(game, gameState)
      if (changes === 'PLAYERS_CHANGED') dispatch(setPlayers(gameState.players))

      if (gameState.running) {
        if (game.host !== user.uid) {
          dispatch(startGame())
          history.push('/loading')
        }
        unsubGame()
      }
    })
  }, [db, dispatch, game, history, user.uid])

  return (
    <div>
      <div>Welcome ! Please share {game?.id} as the game code</div>
      <div>List of players:</div>
      <ol>
        {Object.keys(game.players).map(k => [k, game.players[k]['displayName']]).map(p => <li key={p[0]}>{p[1]}</li>)}
      </ol>
      {user.uid === game.host
        ? <button onClick={handleStart}>start</button>
        : null}
    </div>
  )
}

export default Lobby